import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-available-dark',
  templateUrl: './icon-available-dark.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconAvailableDarkComponent {}
